// (TODO) This is not really doing anything, but maybe a good 'entry point'
import actions from "core/state/actions"
export const useActions = () => ({ ...actions })
